 <template>
<v-card dark flat class="pb-0" height='100%' >

  <!-- <v-date-picker no-title full-width type='month' /> -->
  <v-list class="black pa-0" >
    <v-list-tile @click="launchDateRangePicker" >
      <v-list-tile-content>
        <v-list-tile-title>
          {{params.after}} - {{params.before}}
        </v-list-tile-title>
        <v-list-tile-sub-title>
          <span v-if='invoiceableClients' >{{ invoiceableClients.count }}</span>
          Clients with appointments
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action >
        <v-btn icon ><v-icon >event</v-icon></v-btn>
      </v-list-tile-action>
    </v-list-tile>
  </v-list>
  <v-divider/>

  <v-card-title class='py-0 pl-0 black lighten-2' >
    <v-spacer />
    <!-- <v-text-field label="search" prepend-icon="search" clearable /> -->
    <status-picker v-model='selectedStatuses'/>
    <v-spacer />
  </v-card-title>
  <!-- ID: {{ selectedClientId }} -->
  <v-divider/>

  <v-divider/>
  <request-status :request="request" />
  <!-- <v-btn @click="getClients" :loading="request.loading" /> -->


<!-- :class='getClasses(client)'
@click='setSelectedRelationship(client)' -->
  <v-list class='mb-0 pb-0' >
      <template v-for="(client, index) in invoiceableClients" >
        <v-list-tile
          @click="clientClicked(client)"
          :class="{ 'grey darken-4': (client.id === selectedClientId) }"
          :key="index" >
          <v-list-tile-content >
              <v-list-tile-title class="mb-1">
                {{client.first_name}} {{client.last_name}}
              </v-list-tile-title>
              <v-list-tile-sub-title >
                {{client.count}} {{ $tc('list.appointments', client.count, { count: client.count }) }}
              </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
              <v-btn >{{ $t('btn.createInvoice') }}</v-btn>
          </v-list-tile-action>
        </v-list-tile>

        <v-divider :key='`d-${index}`' ></v-divider>
      </template>

      <v-list-tile v-if='invoiceableClients.length === 0 && !request.loading' >
      <v-list-tile-content>
          <v-list-tile-title>{{ $t('page.noresults') }}</v-list-tile-title>
      </v-list-tile-content>
      </v-list-tile>
  </v-list>
</v-card>
</template>

<script>
import StatusPicker from '@/components/pickers/StatusPicker.vue'
import {STATUSES} from '@/store/constants'
export default {
  name: 'InvoiceableClients',
  props: {
    touch: { type: Number, default: 0 }
  },
  components: {
    StatusPicker
  },
  data () {
    // /api/v3/practitioner/relationships/invoiceable/
    return {
      request: {
        resource: 'ag.spaces.relationships',
        extra: 'invoiceable'
      },
      statuses: STATUSES,
      selectedStatuses: ['N', 'C'],
      selectedClient: null

    }
  },
  mounted () {
    this.getClients()
  },
  watch: {
    params: {
      immediate: true,
      handler () {
        this.getClients()
        this.$emit('update:params', this.params)
      }
    },
    filters: {
      deep: true,
      handler () {
        this.$emit('input', this.filters)
      }
    },
    touch () {
      this.getClients()
    }
  },
  computed: {
    invoiceableClients () {
      return this.getObjectPath(this.request, 'result.results', []) // object, path, default value
    },
    selectedClientId () {
      if (this.selectedClient) { return this.selectedClient.id }
      return null
    },
    params () {
      return {
        after: this.activeDateRange.from,
        before: this.activeDateRange.to,
        statuses: this.selectedStatuses
      }
    },
    activeDateRange () {
      return this.$store.getters.activeDateRange
    },
    filters () {
      let data = {}
      if (this.selectedStatuses && this.selectedStatuses.length > 0) {
        data.statuses = this.selectedStatuses
      }
      this.$emit('input', data)
      return data
    }
  },
  methods: {
    getClients () {
      this.request.params = this.params
      this.$request('get', this.request)
    },
    clientClicked (client) {
      this.selectedClient = client
      this.$emit('selected', client)
    }
  },
  i18n: {
    messages: {
      en: {
        btn: {
          createInvoice: 'Invoice'
        },
        title: {
          summary: '{fromDate} - {toDate}'
        },
        page: {
          title: 'Invoiceable clients',
          subheading: 'Clients with appointments between {after} and {before}',
          noresults: '🎉 You\'ve invoiced all your clients!',
          info: 'This view shows you clients who have appointments that may need invoicing',
          resultsshowing: 'Currently showing clients with appointments between {fromDate} and {toDate}',
          withstatuses: 'With the following statuses'
        },
        list: {
          appointments: 'appointment | appointments'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// InvoiceableClientList.vue?f8983d68